import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import { newsList } from "@/mocks/news";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NewsDetail() {
  const { id } = useParams();
  const news = newsList.find((item) => item.id === id);

  usePageMeta({
    title: news ? `${news.title}-555电影网` : "影视资讯-555电影网",
    description: news ? news.summary.slice(0, 150) : undefined,
    keywords: news ? `${news.category},影视资讯,555电影网` : undefined,
  });

  if (!news) {
    return (
      <div className="mx-auto flex max-w-page flex-col items-center px-4 py-24 md:px-6">
        <div className="flex h-16 w-16 items-center justify-center text-foreground-300">
          <i className="ri-newspaper-line text-4xl"></i>
        </div>
        <p className="mt-4 text-foreground-600">抱歉，没有找到该篇资讯</p>
        <Link
          to="/news"
          className="mt-5 whitespace-nowrap rounded-md bg-secondary-500 px-5 py-2 text-sm text-background-50 transition-colors hover:bg-secondary-600"
        >
          返回资讯列表
        </Link>
      </div>
    );
  }

  const related = newsList.filter((item) => item.id !== news.id).slice(0, 3);

  return (
    <div className="mx-auto max-w-page px-4 py-6 md:px-6 md:py-8">
      <Breadcrumb
        items={[
          { label: "首页", to: "/" },
          { label: "影视资讯", to: "/news" },
          { label: news.category },
        ]}
      />

      <div className="mt-5 grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
        <article className="min-w-0">
          <h1 className="font-heading text-2xl font-bold leading-snug text-foreground-900 md:text-3xl">
            {news.title}
          </h1>
          <div className="mt-4 flex flex-wrap items-center gap-4 border-b border-background-200 pb-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {news.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              作者：{news.author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-global-line"></i>
              来源：{news.source}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {news.views.toLocaleString()} 阅读
            </span>
          </div>

          <div className="mt-6 h-64 w-full overflow-hidden rounded-lg bg-background-200 md:h-80">
            <img
              src={news.cover}
              alt={`${news.title} 配图`}
              title={`${news.title} - 555电影网`}
              className="h-full w-full object-top"
            />
          </div>

          <div className="mt-6 space-y-4 leading-loose text-foreground-700">
            {news.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>

          <div className="mt-6 rounded-lg bg-background-100 p-4 text-xs leading-relaxed text-foreground-400">
            提示：本文内容为 555 电影网的影视资讯演示内容，相关影片与数据均为虚构展示，不代表真实信息。
          </div>

          <div className="mt-8">
            <h2 className="font-heading text-base font-bold text-foreground-900">相关推荐资讯</h2>
            <ul className="mt-4 space-y-3">
              {related.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/news/detail/${item.id}`}
                    className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-secondary-300"
                  >
                    <div className="h-16 w-24 shrink-0 overflow-hidden rounded bg-background-200">
                      <img
                        src={item.cover}
                        alt={`${item.title} 配图`}
                        title={`${item.title} - 555电影网`}
                        className="h-full w-full object-top"
                      />
                    </div>
                    <div className="min-w-0">
                      <p className="line-clamp-2 text-sm font-medium text-foreground-800 transition-colors group-hover:text-secondary-600">
                        {item.title}
                      </p>
                      <p className="mt-1 text-xs text-foreground-400">
                        {item.category} · {item.date}
                      </p>
                    </div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </article>

        <aside className="space-y-6">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h2 className="border-b border-background-200 pb-3 font-heading text-base font-bold text-foreground-900">
              资讯分类
            </h2>
            <div className="mt-3 flex flex-wrap gap-2">
              {Array.from(new Set(newsList.map((item) => item.category))).map((category) => (
                <Link
                  key={category}
                  to="/news"
                  className={`rounded-md px-3 py-1.5 text-sm transition-colors ${
                    category === news.category
                      ? "bg-primary-600 text-background-50"
                      : "bg-background-100 text-foreground-600 hover:text-secondary-600"
                  }`}
                >
                  {category}
                </Link>
              ))}
            </div>
          </div>

          <Link
            to="/news"
            className="flex items-center justify-center gap-1.5 rounded-lg border border-background-200 bg-background-50 py-3 text-sm text-secondary-600 transition-colors hover:border-secondary-300"
          >
            <i className="ri-arrow-left-line"></i>
            返回资讯列表
          </Link>
        </aside>
      </div>
    </div>
  );
}